import MatchedMap from 'utilities/src/matchedMap';
import { ChipBGEnum } from '../types/_bg';
import { type ChipThemeProps } from '../types/_theme';

const chipLinkClasses = 'radius rounded-[6.25rem] px-2 py-1';

const chipLinkColorClasses = new MatchedMap([
  [ChipBGEnum.Dark, 'bg-site-neutrals-500 text-white hover:bg-site-neutrals-800'],
  [ChipBGEnum.Light, 'bg-site-neutrals-50 text-site-neutrals-900'],
]);

const chipTextClasses = 'px-2 py-1';

const chipSiteTheme = ({ bg = 'Dark' }: ChipThemeProps) => ({
  chipLinkClasses,
  chipTextClasses,
  chipLinkColorClasses: chipLinkColorClasses.get(ChipBGEnum[bg]),
});

export default chipSiteTheme;
